import React from "react";

const PrivacyPolicy = () => {
  return (
    <div id="ultra-premium-privacy">
      <style>
        {`
          #ultra-premium-privacy {
            /* Luxury Brand Theme */
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-base: #fbfcfd;
            --glass-bg: rgba(255, 255, 255, 0.65);
            --glass-card: rgba(255, 255, 255, 0.85);
            --glass-border: rgba(255, 255, 255, 0.9);
            --text-dark: #1d1d1f;
            --text-muted: #6e6e73;
            --gradient-accent: linear-gradient(135deg, var(--brand-blue), var(--brand-pink));
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            background-color: var(--bg-base);
            padding: 6rem 2rem;
            min-height: 100vh;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
          }

          /* Ambient Glowing Orbs */
          #ultra-premium-privacy::before,
          #ultra-premium-privacy::after {
            content: '';
            position: absolute;
            border-radius: 50%;
            filter: blur(120px);
            z-index: 0;
            opacity: 0.3;
            animation: floatPrivacy 12s ease-in-out infinite alternate;
          }

          #ultra-premium-privacy::before {
            width: 500px; height: 500px;
            background: rgba(0, 168, 232, 0.15);
            top: -10%; left: -5%;
          }

          #ultra-premium-privacy::after {
            width: 600px; height: 600px;
            background: rgba(236, 28, 116, 0.12);
            bottom: -10%; right: -5%;
            animation-delay: -5s;
          }

          @keyframes floatPrivacy {
            0% { transform: translate(0, 0); }
            100% { transform: translate(30px, 40px); }
          }

          #ultra-premium-privacy * {
            box-sizing: border-box;
            position: relative;
            z-index: 1;
          }

          .privacy-container {
            max-width: 1000px;
            margin: 0 auto;
          }

          /* Header Section */
          .privacy-header {
            text-align: center;
            margin-bottom: 4rem;
            animation: fadeDown 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
          }

          @keyframes fadeDown {
            from { opacity: 0; transform: translateY(-30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .privacy-header h1 {
            font-size: 3.5rem;
            font-weight: 800;
            color: var(--text-dark);
            letter-spacing: -0.04em;
            margin: 0 0 1rem 0;
          }

          .privacy-header h1 span {
            background: var(--gradient-accent);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .privacy-intro {
            background: var(--glass-bg);
            backdrop-filter: blur(24px);
            -webkit-backdrop-filter: blur(24px);
            border: 1px solid var(--glass-border);
            border-radius: 24px;
            padding: 2.5rem;
            text-align: center;
            font-size: 1.15rem;
            color: var(--text-muted);
            line-height: 1.7;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.03);
            margin-bottom: 4rem;
            animation: fadeUp 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s both;
          }

          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          /* Cards Grid */
          .privacy-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
          }

          .privacy-card {
            background: var(--glass-card);
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
            border: 1px solid var(--glass-border);
            border-radius: 28px;
            padding: 2.5rem;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            animation: fadeUp 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) 0.4s both;
          }

          .privacy-card.full-width {
            grid-column: 1 / -1;
          }

          .privacy-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px rgba(0, 168, 232, 0.06);
            background: #ffffff;
            border-color: rgba(236, 28, 116, 0.15);
          }

          .privacy-card h2 {
            font-size: 1.4rem;
            font-weight: 700;
            color: var(--text-dark);
            margin: 0 0 1.2rem 0;
            letter-spacing: -0.01em;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          /* Subtle dot before headings */
          .privacy-card h2::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: var(--gradient-accent);
          }

          .privacy-card p {
            font-size: 1.05rem;
            color: var(--text-muted);
            line-height: 1.6;
            margin: 0 0 1rem 0;
          }

          /* Custom List Styling */
          .privacy-card ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .privacy-card ul li {
            font-size: 1.05rem;
            color: var(--text-muted);
            margin-bottom: 0.8rem;
            padding-left: 1.5rem;
            position: relative;
            line-height: 1.5;
          }

          .privacy-card ul li::before {
            content: '→';
            position: absolute;
            left: 0;
            color: var(--brand-blue);
            font-weight: bold;
          }

          /* Contact & Disclaimer styling */
          .contact-details {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }
          
          .contact-details strong {
            color: var(--text-dark);
          }

          .disclaimer-card {
            background: rgba(236, 28, 116, 0.03);
            border-color: rgba(236, 28, 116, 0.1);
          }

          .disclaimer-card p {
            font-size: 0.95rem;
            color: #8e8e93;
            font-style: italic;
            margin: 0;
          }

          /* Responsive */
          @media (max-width: 768px) {
            #ultra-premium-privacy { padding: 4rem 1.5rem; }
            .privacy-header h1 { font-size: 2.8rem; }
            .privacy-grid { grid-template-columns: 1fr; }
            .privacy-card { padding: 2rem; }
          }
        `}
      </style>

      <div className="privacy-container">
        
        <header className="privacy-header">
          <h1>Privacy <span>Policy</span></h1>
        </header>

        <div className="privacy-intro">
          At <strong>Maa Sadhana Foundation Wellness Center</strong>, we take your privacy seriously and are committed to elegantly safeguarding your personal information. This Privacy Policy strictly outlines how we securely collect, use, and thoughtfully protect your data.
        </div>

        <div className="privacy-grid">
          
          <section className="privacy-card">
            <h2>1. Information We Collect</h2>
            <ul>
              <li>Personal details like name, email, phone number, and address.</li>
              <li>General wellness-related information (if securely provided by the user).</li>
              <li>Non-personal info such as browser type & encrypted cookies.</li>
            </ul>
          </section>

          <section className="privacy-card">
            <h2>2. How We Use Your Data</h2>
            <ul>
              <li>To seamlessly provide elite counseling and wellness support services.</li>
              <li>To optimize user experience and enhance website performance.</li>
              <li>To maintain highly secure records for continuous support and follow-ups.</li>
              <li>To thoughtfully respond to user inquiries and bespoke service requests.</li>
            </ul>
          </section>

          <section className="privacy-card full-width">
            <h2>3. Confidentiality & Data Protection</h2>
            <p>
              All personal information provided by users is kept strictly and absolutely confidential. We do not share your sensitive details with unauthorized third parties. Our premium platform implements top-tier, enterprise-grade security measures to thoroughly protect your data against any breach.
            </p>
          </section>

          <section className="privacy-card">
            <h2>4. Third-Party Sharing</h2>
            <ul>
              <li>We absolutely do not sell, rent, or misuse your personal data.</li>
              <li>Information is shared only with authorized professional counselors if explicitly required.</li>
              <li>Any legal requests by government authorities will be handled strictly in compliance with the law.</li>
            </ul>
          </section>

          <section className="privacy-card">
            <h2>5. Your Ultimate Rights</h2>
            <ul>
              <li>Request full access to view your securely stored data.</li>
              <li>Effortlessly opt-out of marketing and promotional emails.</li>
              <li>Request complete data deletion in compliance with modern legal norms.</li>
            </ul>
          </section>

          <section className="privacy-card">
            <h2>6. Secure Contact</h2>
            <div className="contact-details">
              <p><strong>Address:</strong> NH-2, Delhi - Mathura Hwy, near Heera lal ki Pyau, Sikandra, Agra, Uttar Pradesh 282007</p>
              <p><strong>Phone Support:</strong> +91 7535807012 / +91 7535807008</p>
            </div>
          </section>

          <section className="privacy-card disclaimer-card">
            <h2>7. Medical Disclaimer</h2>
            <p>
              We do not provide clinical medical advice. We are a dedicated, holistic counseling and wellness center. Please consult a registered medical practitioner for critical medical emergencies.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;